module.exports = __webpack_public_path__ + "img/home_content_bg.fc9508f5.png";